import React from 'react';

import RedInfoIcon from 'icons/info-red.svg';
import InfoIcon from 'icons/info.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { sendAnalytics } from 'components/helpers/analytics';
import * as IntercomHelperModule from 'components/helpers/intercom';

export default function TrackedPersonnelUsageBanner({
  hasReachedLimit,
  usage,
}) {
  const currentActor = useCurrentActor();

  const { t: i18nTCommon } = useTranslation('common');

  const handleUpgradeClick = () => {
    IntercomHelperModule.launchIntercomWithMessage(
      "Hello, I'm interested in upgrading my Training Register plan.",
    );

    sendAnalytics('Upgrade clicked from usage banner notification', {
      account: currentActor.account,
      division: currentActor.division,
      user: currentActor.user,
    });
  };

  return (
    <div className='tw-mb-3 tw-flex tw-items-center tw-rounded-md tw-border-1 tw-border-solid tw-border-grey-100 tw-bg-white tw-px-5 tw-py-3 tw-text-m'>
      {hasReachedLimit ?
        <RedInfoIcon
          className='[&_path]:tw-fill-red-600'
          height='24px'
          width='24px'
        />
      : <InfoIcon
          className='[&_path]:tw-fill-cyan-600'
          height='24px'
          width='24px'
        />
      }
      <span className='tw-ml-3'>
        <div className='tw-font-medium'>
          {hasReachedLimit ?
            i18nTCommon('training.reachedLimit')
          : i18nTCommon('training.approachingLimit')}
        </div>
        <span>
          {i18nTCommon('personnel.trackedUsage', {
            allowance:
              currentActor.subscription.attributes.trackedPersonnelAllowance,
            usage,
          })}
        </span>
      </span>
      {['primary', 'administrator'].includes(
        currentActor.user.attributes.accessType,
      ) &&
        hasReachedLimit && (
          <OutlinedButton
            className='tw-ml-auto'
            color='grey'
            onClick={handleUpgradeClick}
            size='sm'
          >
            {i18nTCommon('shared.upgradePlan')}
          </OutlinedButton>
        )}
    </div>
  );
}

TrackedPersonnelUsageBanner.propTypes = {
  usage: PropTypes.number.isRequired,
};
